import * as React from 'react'

import { theme } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  width?: number
  height?: number
  useCurrentColor?: boolean
}

function Logo(props: Props) {
  const { height, width, useCurrentColor = false } = props

  return (
    <svg
      width={width || theme.dimensions.sidebarLogoSize}
      height={height || 28}
      viewBox="0 0 134 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8176 24.877C20.411 26.8299 17.3434 28.0001 14.0026 28.0001C10.6617 28.0001 7.59419 26.8299 5.1875 24.877C7.59419 22.9241 10.6617 21.7539 14.0026 21.7539C17.3434 21.7539 20.411 22.9241 22.8176 24.877Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10817 21.4977C3.39924 19.4731 2.36923 16.8569 2.36923 14C2.36923 7.57651 7.5765 2.36923 14 2.36923C20.4235 2.36923 25.6308 7.57651 25.6308 14C25.6308 16.8569 24.6008 19.4731 22.8918 21.4977C23.4798 21.8651 24.0433 22.2677 24.5793 22.7027L24.8135 22.8927C26.8044 20.4745 28 17.3769 28 14C28 6.26802 21.732 0 14 0C6.26801 0 0 6.26802 0 14C0 17.3769 1.19557 20.4745 3.18651 22.8927L3.42067 22.7027C3.95667 22.2677 4.52019 21.8651 5.10817 21.4977Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <ellipse
        cx="14.0022"
        cy="13.5691"
        rx="5.16923"
        ry="5.16923"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        d="M133.752 23.0462H130.306V3.87695H133.752V23.0462Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        d="M124.115 11.6405V10.1231H127.508V23.0462H124.115V21.1464C123.174 22.3575 121.823 22.963 120.119 22.963C118.496 22.963 116.817 22.3326 115.648 21.0718C114.496 19.7943 113.938 18.2533 113.938 16.4118C113.938 14.587 114.496 13.0174 115.648 11.74C116.817 10.4626 118.414 9.90771 120.037 9.90771C121.741 9.90771 123.174 10.4294 124.115 11.6405ZM118.293 18.9317C118.926 19.5787 119.729 19.9022 120.703 19.9022C121.677 19.9022 122.48 19.5787 123.113 18.9317C123.762 18.2681 124.115 17.422 124.115 16.3934C124.115 15.3649 123.762 14.5271 123.113 13.8801C122.48 13.2165 121.677 12.8847 120.703 12.8847C119.729 12.8847 118.926 13.2165 118.293 13.8801C117.66 14.5271 117.331 15.3649 117.331 16.3934C117.331 17.422 117.66 18.2681 118.293 18.9317Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        d="M102.503 10.1231V12.414C102.784 11.6169 103.482 10.8758 103.879 10.6078C104.246 10.3599 105.09 9.90771 105.964 9.90771V13.4001C104.991 13.2644 104.284 13.6994 103.582 14.2455C102.839 14.8244 102.517 15.6446 102.517 16.8656V23.0462H99.0713V10.1231H102.503Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        d="M67.6697 23.0462C65.793 23.0462 64.2235 22.4158 62.9613 21.155C61.7157 19.8943 60.9482 18.3768 60.9482 16.5188C60.9482 14.6609 61.7157 13.0596 62.9613 11.7989C64.2235 10.5381 65.793 9.90771 67.6697 9.90771C68.8821 9.90771 69.9866 10.198 70.9831 10.7786C71.9796 11.3592 72.8759 12.1389 73.3907 13.1177L70.4848 14.7351C70.2357 14.2208 69.8537 13.8144 69.3389 13.5158C68.8406 13.2172 68.2759 13.0679 67.6448 13.0679C66.6815 13.0679 65.8844 13.3914 65.2532 14.0384C64.6221 14.6687 64.2471 15.4816 64.2471 16.4769C64.2471 17.4391 64.6221 18.252 65.2532 18.9155C65.8844 19.5459 66.6815 19.8611 67.6448 19.8611C68.2925 19.8611 68.8655 19.7201 69.3638 19.4381C69.8786 19.1395 70.4013 18.733 70.6504 18.2188L73.4406 19.8113C72.8925 20.8067 72.1119 21.5946 71.0988 22.1753C70.1023 22.7559 68.8655 23.0462 67.6697 23.0462Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        d="M55.3521 11.6515V10.1231H58.7983V23.0462H55.3521V21.218C54.3958 22.4368 53.0231 23.0462 51.2919 23.0462C49.6431 23.0462 47.938 22.4117 46.7508 21.1429C45.5802 19.8573 45.0137 18.3065 45.0137 16.4533C45.0137 14.6168 45.5802 13.0372 46.7508 11.7517C47.938 10.4661 49.5601 9.90771 51.2089 9.90771C52.9402 9.90771 54.3958 10.4328 55.3521 11.6515ZM49.437 18.9892C50.08 19.6403 50.8962 19.9659 51.8855 19.9659C52.8747 19.9659 53.6909 19.6403 54.3339 18.9892C54.9934 18.3214 55.3521 17.4699 55.3521 16.4348C55.3521 15.3997 54.9934 14.5565 54.3339 13.9054C53.6909 13.2376 52.8747 12.9037 51.8855 12.9037C50.8962 12.9037 50.08 13.2376 49.437 13.9054C48.794 14.5565 48.4598 15.3997 48.4598 16.4348C48.4598 17.4699 48.794 18.3214 49.437 18.9892Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        d="M43.5058 3.88847V7.37364C41.7581 7.25523 40.931 8.24378 40.931 9.80003V10.1231H43.5058V13.6179H40.9212V23.0462H37.475V13.6179H35.752V10.1231H37.475V9.80003C37.475 7.99004 38.227 6.42583 39.1998 5.51239C40.1891 4.58202 41.5932 3.77006 43.5058 3.88847Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        d="M112.001 23.0461H108.555V10.123H112.001V23.0461Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <ellipse
        cx="110.276"
        cy="5.81541"
        rx="1.93847"
        ry="1.93846"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.6744 23.0461C94.2431 23.0461 97.136 20.1532 97.136 16.5846C97.136 13.016 94.2431 10.123 90.6744 10.123C87.1058 10.123 84.2129 13.016 84.2129 16.5846C84.2129 20.1532 87.1058 23.0461 90.6744 23.0461ZM90.6744 19.923C92.5182 19.923 94.0129 18.4284 94.0129 16.5846C94.0129 14.7408 92.5182 13.2461 90.6744 13.2461C88.8307 13.2461 87.336 14.7408 87.336 16.5846C87.336 18.4284 88.8307 19.923 90.6744 19.923Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
      <path
        d="M75.167 17.6666V7.99334L78.7597 6.89258V10.1438H82.3075V13.5341H78.7597C78.7597 14.7083 78.7148 16.6628 78.7148 17.5787C78.7148 19.0317 79.6081 19.6317 80.5043 19.6317C81.4006 19.6317 82.2017 19.1002 82.2017 19.1002L83.3516 22.1307C83.3516 22.1307 80.8229 23.7188 78.3071 22.7122C75.7913 21.7056 75.167 19.7758 75.167 17.6666Z"
        fill={useCurrentColor ? 'currentColor' : '#FF355E'}
      />
    </svg>
  )
}

export default observer(Logo)
